/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_SourceInputs */

const en_pol_source = /** @type {(inputs: Pol_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const id_pol_source = /** @type {(inputs: Pol_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumber`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {Pol_SourceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_source = /** @type {((inputs?: Pol_SourceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_SourceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_source(inputs)
	return en_pol_source(inputs)
});